import type { BookOverride, ClientBookMode, StaffEngagement } from '@salonomy/types';

/**
 * Client-side mirror of apps/api/src/modules/staff/book-mode.ts. Kept byte-for-byte in step with
 * the server so the StaffModal sealed-book preview matches the API's source of truth exactly — the
 * operator must see the sealing consequence at the moment a staff member is created/edited, never
 * discover it only after a renter_id is silently set on insert. If the API's ownsSealedBook rule
 * changes, change this too (they are the same rule, expressed twice for UX).
 *
 * Whether a staff member owns a SEALED client book — i.e. their clients/appointments carry a
 * renter_id and are RLS-isolated from the rest of the salon. The salon's mode is the default;
 * a per-person override wins (used in `mixed` salons). See design screen S1 and ADR-0005.
 *
 *   shared salon → never sealed
 *   sealed salon → always sealed (unless overridden to shared)
 *   mixed  salon → sealed for chair renters, shared for employed (unless overridden)
 */
export function ownsSealedBook(
  mode: ClientBookMode,
  engagement: StaffEngagement,
  override: BookOverride,
): boolean {
  if (override === 'sealed') return true;
  if (override === 'shared') return false;
  if (mode === 'sealed') return true;
  if (mode === 'mixed') return engagement === 'chair_renter';
  return false;
}
